module.exports = __webpack_public_path__ + "img/export-upload.798fff42.svg";